import { API_URL as api_url } from '../services/api';
import { ENABLE_INTEGRATION_GOOGLE_DRIVE } from '../config/features';
import { GOOGLE_CLIENT_ID, GOOGLE_API_KEY } from '../config';
const API_URL = `${api_url}/web`;
export default API_URL;

// Google Drive picker; set per deployment at build time (the picker fails without them).
export const google_client_id = GOOGLE_CLIENT_ID;
export const google_api_key = GOOGLE_API_KEY;
// Drive buttons show only when the integration is on and this build has both keys.
export const GOOGLE_DRIVE_PICKER_ENABLED = Boolean(
  ENABLE_INTEGRATION_GOOGLE_DRIVE && google_client_id && google_api_key,
);
